import type { AxiosInstance } from 'axios';
import queryString from 'query-string';
import type * as KolApi from './interfaces/kol.js';
import { transformDates } from './transformers/index.js';
import { download } from './utils.js';

export class KolSearchClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  submitKolSearch = (data: KolApi.SubmitKolSearch.Request) => {
    return this.authenticatedClient.post<KolApi.SubmitKolSearch.Response<Date>>(`/chat/${data.chatIdentifier}/kol-table-search`, {
      identifier: data.identifier,
      form: data.form,
      recommendations: data.recommendations,
      brandIdentifier: data.brandIdentifier,
      filters: data.filters || [],
      sort: data.sort || [],
    }, {
      transformResponse: transformDates,
    }).then(res => res.data);
  };

  cancelKolSearch = (data: KolApi.CancelKolSearch.Request) => {
    return this.authenticatedClient.patch<KolApi.CancelKolSearch.Response>(`/chat/${data.chatIdentifier}/kol-search/${data.kolSearchId}/cancel`);
  };

  updateKolSearchProfile = (data: KolApi.UpdateKolSearchProfile.Request) => {
    return this.authenticatedClient.patch<KolApi.UpdateKolSearchProfile.Response<Date>>(`/chat/${data.chatIdentifier}/kol-search/${data.kolSearchId}/update-profile`, {
      kolId: data.kolId,
    }, { transformResponse: transformDates }).then(res => res.data);
  };

  downloadKolProfile = (data: KolApi.DownloadKolProfile.Request) => {
    return this.authenticatedClient.get<Blob>(`/chat/kol/${data.kolId}/report`, {
      responseType: 'blob',
    });
  };

  getKolSearchRecommendations = ({ filters, ...data }: KolApi.GetKolSearchRecommendations.Request) => {
    const qs = queryString.stringify({
      ...data,
      filters: JSON.stringify(filters),
    }, {
      arrayFormat: 'bracket',
      skipNull: true,
    });
    return this.authenticatedClient.get<KolApi.GetKolSearchRecommendations.Response>(`/chat/kol-search/recommendations?${qs}`, {
      transformResponse: transformDates,
    }).then(res => res.data);
  };

  downloadKolSearch = (data: KolApi.DownloadKolSearch.Request) => {
    return download(this.authenticatedClient, `/chat/kol-search/${data.kolSearchId}/report`);
  };

  getKolSearchProfileText = (data: KolApi.GetKolSearchProfileText.Request) => {
    return this.authenticatedClient.get<KolApi.GetKolSearchProfileText.Response>(`/chat/kol-search/${data.kolSearchId}/profile-text?tts=${data.tts}`).then(res => res.data.value);
  };
}